import {
  createRouter,
  createWebHistory
} from "vue-router";

const routes = [{
  path: "/",
  redirect: "/home"
}, {
  path: "/home",
  name: "Home",
  component: () => import("../views/index.vue"),
  meta: {
    isLogin: false
  },
}, {
  path: "/login",
  name: "Login",
  component: () => import("../views/login.vue"),
  meta: {
    isLogin: false
  }
}, {
  path: "/gallery/list",
  name: "Gallerylist",
  component: () => import("../views/gallery/list.vue"),
  meta: {
    isLogin: false
  }
}, {
  path: "/gallery/detail",
  name: "Gallerydatail",
  component: () => import("../views/gallery/detail.vue"),
  meta: {
    isLogin: false
  },
}, {
  path: "/mine",
  name: "Mine",
  component: () => import("../views/mine/index.vue"),
  meta: {
    isLogin: true
  },
}];

const router = new createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;